import {Box, Stack, Typography} from "@mui/material";
import {Outlet} from "react-router-dom";

import React, {useRef} from "react";
import {useNavigate} from "react-router-dom";
import {APP_ENV, APP_PACKAGE} from "../../../utils/constants";
import User from "../../Shared/User";

import DotStretchLoading from "../../Shared/DotStretchLoading";
import {useAppContext} from "@/contexts/AppContext.tsx";
import {grey} from "@mui/material/colors";

declare global {
    interface Window {
        showCollectorDialog: any;
    }
}

export function LoadingBackdrop() {
    const {theme} = useAppContext();

    return (
        <Box position="absolute" top={0} left={0} bottom={0} right={0} zIndex={99}
             bgcolor={theme === 'dark' ? 'white' : ''}>
            <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
                <Stack direction="row" sx={{filter: theme === 'dark' ? 'invert(1)' : 'invert(0)'}}>
                    <DotStretchLoading/>
                </Stack>
            </Stack>
        </Box>
    )
}

export default function DefaultLayout() {
    const feedback = useRef<any>(null);
    const navigate = useNavigate();
    const {uiVisual, theme} = useAppContext();

    const invert = {
        filter: theme === 'dark' ? 'invert(1)' : 'invert(0)'
    };
    const wrapper = {
        classic: {
            bgcolor: theme === 'dark' ? grey[200] : '',
            borderBottom: '1px solid #e0e0e0'
        },
        modern: {
            bgcolor: theme === 'dark' ? '#f8fdff' : '',
            borderBottom: theme === 'dark' ? '1px solid #e5edff' : '1px solid #ECF4FF'
        }
    };
    const border = {
        classic: {
            borderBottom: '1px solid #e0e0e0'
        },
        modern: {
            borderBottom: theme === 'dark' ? '1px solid #e5edff' : '1px solid #ECF4FF'
        }
    };

    return (
        <Box minHeight="100vh" overflow="hidden" sx={invert}>
            <Box height={50} width="100%" py={1} px={2} position="relative" zIndex={1} sx={wrapper[uiVisual]}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" onClick={() => navigate("/")} sx={{cursor: 'pointer'}}>
                        <img alt="icon"
                             src="/assets/icon.png"
                             width={24}
                             height={24}
                             className="me-2"
                             style={invert}/>
                        <Typography fontSize={15} fontWeight={600}>Partner Portal</Typography>
                    </Stack>
                    <User/>
                </Stack>
            </Box>
            <React.Suspense fallback={<LoadingBackdrop/>}>
                <Box minHeight="calc(100vh - 100px)" sx={border[uiVisual]} overflow="hidden">
                    <Outlet/>
                </Box>
            </React.Suspense>
            <Box p={2} height={50} width="100%" sx={wrapper[uiVisual]}>
                <Stack direction="row" justifyContent="space-between">
                    <Typography sx={{fontSize: 13, color: 'grey.700'}}>
                        &copy; {new Date().getFullYear()} VNETWORK JSC (build-{APP_PACKAGE.version}.{APP_ENV})
                    </Typography>
                    <Typography
                        ref={feedback}
                        onClick={() => window.showCollectorDialog() as any}
                        sx={{fontSize: 13, color: 'grey.700', cursor: 'pointer'}}>
                        Feedback
                    </Typography>
                </Stack>
            </Box>
        </Box>
    );
}
